import ListProgram from './Main'
import { getBaseMetaTitle } from '@/environments'

const route = {
  path: '/archive/program',
  name: 'programArchive',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: ListProgram
}

export default route
